import { render } from "./ExtendedRouterLink.vue?vue&type=template&id=3c0c248b"
import script from "./ExtendedRouterLink.vue?vue&type=script&lang=js"
export * from "./ExtendedRouterLink.vue?vue&type=script&lang=js"
script.render = render

export default script